import { Grid, Box, Typography } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import { Student } from '../../../store/types';
import useLocal from '../../../../../../store/local/hooks/useLocal';

const useStyles = makeStyles({
  label: {
    lineHeight: 0,
    fontSize: '.65rem',
    fontWeight: 'bold',
  },
  htmlContent: {
    fontSize: '.65rem',
    background: '#fafafa',
    border: '1px solid #ccc',
    padding: '5px 10px',
    minHeight: '1.7rem',
  },
});

export default ({ student, loading }: {
  student: Student
  loading: boolean
}) => {
  const classes = useStyles();
  const { text } = useLocal();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={2}>
          <Typography variant="overline" className={classes.label}>{text.student.details.emailLabel}</Typography>
        </Grid>
        <Grid item sm={10}>
          <Typography variant="body2" className={classes.htmlContent}>{loading ? '' : student?.email}</Typography>
        </Grid>
      </Grid>

      <Box mt={2} />

      <Grid container spacing={2}>
        <Grid item sm={2}>
          <Typography variant="overline" className={classes.label}>{text.student.details.statusLabel}</Typography>
        </Grid>
        <Grid item sm={10}>
          <Typography variant="body2" className={classes.htmlContent}>
            {loading ? ''
              : text.student.details.deletedEnum[student.deleted.toString()]}
          </Typography>
        </Grid>
      </Grid>

      <Box mt={2} />

      <Grid container spacing={2}>
        <Grid item sm={2}>
          <Typography variant="overline" className={classes.label}>{text.student.details.roleLabel}</Typography>
        </Grid>
        <Grid item sm={10}>
          <Typography variant="body2" className={classes.htmlContent}>{loading ? '' : student?.userRolesDesc}</Typography>
        </Grid>
      </Grid>

      <Box mt={2} />

      <Grid container spacing={2}>
        <Grid item sm={2}>
          <Typography variant="overline" className={classes.label}>{text.student.details.validDateLabel}</Typography>
        </Grid>
        <Grid item sm={10}>
          <Typography variant="body2" className={classes.htmlContent}>{loading ? '' : student?.validAt}</Typography>
        </Grid>
      </Grid>

      <Box mt={2} />

      <Grid container spacing={2}>
        <Grid item sm={2}>
          <Typography variant="overline" className={classes.label}>{text.student.details.confirmedDateLabel}</Typography>
        </Grid>
        <Grid item sm={10}>
          <Typography variant="body2" className={classes.htmlContent}>{loading ? '' : student?.confirmedAt}</Typography>
        </Grid>
      </Grid>

      <Box mt={2} />

      <Grid container spacing={2}>
        <Grid item sm={2}>
          <Typography variant="overline" className={classes.label}>{text.student.details.createdDateLabel}</Typography>
        </Grid>
        <Grid item sm={10}>
          <Typography variant="body2" className={classes.htmlContent}>{loading ? '' : student?.createdAt}</Typography>
        </Grid>
      </Grid>
    </>
  );
};
